import { useState } from 'react';

import chatWithTivy from '/images/icon-chat-with-tivy.png';
import Chat from '@/components/chat';
import { MessageRole } from '@/types/socket';
import { ChatProvider } from '@/contexts/chat-context';
import { Tooltip } from '@nextui-org/react';
import { capitalize } from '@/helper/capitalize';

interface TivyChatProps {
  userId: string;
  userName: string;
}

const TivyChat = ({ userId, userName }: TivyChatProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const DEFAULT_PARAMETERS = [{ key: 'userId', value: userId }];
  const DEFAULT_MESSAGES = [
    {
      role: MessageRole.ASSISTANT,
      content: `Hey ${capitalize(userName)}. I'm Coach Tivy, here to support you with your fundraising goals.\n\nHow can I assist you today?`
    }
  ];

  const handleChatVisibility = () => {
    setIsOpen(isShown => !isShown);
  };

  return (
    <ChatProvider
      config={{
        type: 'SIMULATION',
        messages: DEFAULT_MESSAGES,
        parameters: DEFAULT_PARAMETERS
      }}
    >
      {isOpen ? (
        <div className="fixed bottom-5 right-5 z-50">
          <Chat onClose={handleChatVisibility} className="w-[450px] h-[calc(100vh-200px)] shadow" />
        </div>
      ) : (
        <button onClick={handleChatVisibility}>
          <Tooltip content="Chat with Tivy" placement="left" color="foreground">
            <img src={chatWithTivy} alt="Chat with Tivy" className="w-12 h-12 object-contain" />
          </Tooltip>
        </button>
      )}
    </ChatProvider>
  );
};

export default TivyChat;
